module.exports = __webpack_public_path__ + "images/start-harmonie-muenchen-2-baee48f46858399db2f9cf6f5957088b.jpg";